import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, RotateCcw } from "lucide-react";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <main className="min-h-screen flex items-center justify-center p-6" data-testid="payment-cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        className="kawaii-card max-w-md w-full p-8 md:p-10 text-center"
      >
        <div className="text-5xl mb-3">🌷</div>
        <h1 className="font-heading text-3xl text-kawaii-text">No worries — no charge</h1>
        <p className="text-sm font-body text-kawaii-textSoft mt-3 leading-relaxed">
          Your card wasn't touched. Whenever you're ready, we're here.
        </p>
        <div className="mt-6 flex flex-col gap-2">
          <button
            onClick={() => nav("/")}
            data-testid="cancel-home-btn"
            className="kawaii-btn w-full py-3 rounded-full bg-gradient-to-r from-kawaii-pink to-kawaii-peach text-white font-heading font-semibold text-sm shadow-md inline-flex items-center justify-center gap-2"
          >
            <Home className="w-4 h-4" strokeWidth={2.5} /> Back to my calendar
          </button>
          <button
            onClick={() => nav(-1)}
            className="kawaii-btn w-full py-2.5 rounded-full bg-white border border-kawaii-border text-kawaii-text font-body font-semibold text-sm inline-flex items-center justify-center gap-2"
          >
            <RotateCcw className="w-4 h-4" strokeWidth={2.5} /> Give it another go
          </button>
        </div>
      </motion.div>
    </main>
  );
}
